<template>
	<div>
		<div class="container">
		<!-- <footer-s></footer-s> -->
		<loginHeader></loginHeader>
		<div class="about">
			<img src="../../assets/img/company_bg.png" class="about-sign" />
			<div class="bn-box">
				<div :class="isFixed?'bn-left-bg bn-left-bg-fixed':'bn-left-bg'" >
					<div class="bn-left">

						<ul class="bn-left-list">
							<li class="bn-left-padding">
								<i class="bn-left-ic"></i>
							</li>
							<li>
								<div :class="titleItemActive==0?'menu-item active':'menu-item'" @click="scrollTo(0)">
									<i class="bn-left-i"></i>
									简历投递
								</div>
							</li>
							<li>
								<div :class="titleItemActive==1?'menu-item active':'menu-item'" @click="scrollTo(1)">
									<i class="bn-left-i"></i>
									国内产品签约经理
								</div>
							</li>
							<li>
								<div :class="titleItemActive==2?'menu-item active':'menu-item'" @click="scrollTo(2)">
									<i class="bn-left-i"></i>
									海外产品签约经理
								</div>
							</li>
							<li>
								<div :class="titleItemActive==3?'menu-item active':'menu-item'" @click="scrollTo(3)">
									<i class="bn-left-i"></i>
									国内产品助理
								</div>
							</li>
							<li>
								<div :class="titleItemActive==4?'menu-item active':'menu-item'" @click="scrollTo(4)">
									<i class="bn-left-i"></i>
									订房文员
								</div>
							</li>
							<li>
								<div :class="titleItemActive==5?'menu-item active':'menu-item'" @click="scrollTo(5)">
									<i class="bn-left-i"></i>
									售后文员
								</div>
							</li>
							<li>
								<div  :class="titleItemActive==6?'menu-item active':'menu-item'" @click="scrollTo(6)">
									<i class="bn-left-i"></i>
									运营专员
								</div>
							</li>
					
							<li class="bn-left-padding">
								<i class="bn-left-ico"></i>
							</li>
						</ul>

					</div>
				</div>

				<div class="bn-right">
					<ul class="about-br bn-padding">
						<li class="about-item">
							<h1>简历投递</h1>
							<p>欢迎投递简历至以下邮箱，或电话咨询</p>
							<p>联系邮箱：hr-1@cnbooking.net</p>
							<p>联系电话：0755-2588 4156</p>
							<p>地　　址：深圳市罗湖区人民南路3012号天安国际大厦C座25层。</p>
						

						</li>
						<li class="about-item">
							<h1>国内产品签约经理</h1>
							<p>2-4人/经验2年以上/大专及以上/全职</p>
							
							<p class="bn-mg-top">工作职责</p>
							<p>1、负责对酒店进行考察评估，洽谈合作方案及签约等维护工作; </p>
							<p>2、负责分管区域内酒店的价格谈判，协调处理与合作酒店的业务关系（包括预定、结算、投诉等）；</p>
							<p>3、维护分管区域内酒店的价格并定期与同行进行比较，并适时进行调整	</p>
							<p>4、关注合作酒店的房态情况以保证相关业务的正常运转.</p>
							<p>5、了解掌握酒店业务市场的各种信息，完成合作酒店的评估与推荐。</p>
							<p>6、定期针对所负责的区域做出差拜访,维护酒店关系，洽谈深入合作.</p>
							<p>7、负责对销售部门和操作中心以及财务工作提供最便利的工作衔接</p>
							
							<p class="bn-mg-top">任职资格：</p>
							<p>1、熟悉酒店订房业务及多样化组合产品。 </p>
							<p>2、有丰富的产品策划经验，熟悉产品策划方法和操作模式，具备全面的产品能力，并有比较成功的产品推出的经历。 </p>
							<p>3、大专及以上学历，有2年以上旅游行业从业经验</p>
							<p>4、主动性强，具有优秀的理解、沟通与协调能力，很强的文字表达能力。</p>
					

						</li>
						<li class="about-item">
							<h1>海外产品签约经理</h1>
							<p>1人/经验1年以上/大专及以上/全职</p>
							
							<p class="bn-mg-top">工作职责</p>
							<p>1、协助产品经理进行合作酒店的产品系统维护</p>
							<p>2、协助处理与合作酒店之间的业务</p>
							<p>3、定期了解同行业相关行情,及时上报并处理</p>
							<p>4、关注负责合作酒店的房态并保证各项业务的正常运转；</p>
							
							
							
							<p class="bn-mg-top">任职资格</p>
							<p>1、具备熟练的英文说读写能力。</p>
							<p>2、熟悉酒店订房业务及多样化组合产品</p>
							<p>3、大专及以上学历，有1年以上旅游行业从业经验</p>
							<p>4、主动性强，具有优秀的理解、沟通与协调能力，很强的文字表达能力</p>
						</li>
						<li class="about-item">
							<h1>国内产品助理</h1>
							<p>4-6人/经验2年以上/大专及以上/全职</p>
							
							<p class="bn-mg-top">主要职责</p>
							<p>1、协助产品经理进行合作酒店的产品系统维护</p>
							<p>2、协助处理与合作酒店之间的业务</p>
							<p>3、定期了解同行业相关行情,及时上报并处理</p>
							<p>4、关注负责合作酒店的房态并保证各项业务的正常运转；</p>
							<p>5、根据产品总监/经理的指示进行HOLD房，创造收益。</p>
							
							<p class="bn-mg-top">任职资格：</p>
							<p>1、熟悉酒店订房业务及多样化组合产品。 </p>
							<p>2、有丰富的产品策划经验，熟悉产品策划方法和操作模式，具备全面的产品能力，并有比较成功的产品推出的经历。 </p>
							<p>3、大专及以上学历，有2年以上旅游行业从业经验</p>
							<p>4、主动性强，具有优秀的理解、沟通与协调能力，很强的文字表达能力。</p>
				
						</li>
						<li class="about-item">
							<h1>订房文员</h1>
							<p>2人/经验不限/大专及以上/全职</p>
							
							<p class="bn-mg-top">工作职责：注重保持与旅行社及订房中心的良好沟通，为她们提供快速准确地酒店报价及客房预订服务。</p>
							<p>1、协助预订主管负责酒店的签约、价格、房态维护。</p>
							<p>2、接听线上线下的客户预订咨询，高效率的处理客户订单。</p>
							<p>3、有明确的职业规划，热爱旅游业，立志在此行业发展，有一定抗压能力。</p>
							
							
							<p class="bn-mg-top">职位要求：</p>
							<p>1、对各大酒店的位置和软硬件设施有深入的了解，有一定人脉关系者优先。</p>
							<p>2、大专或以上学历，有经验者优先考虑；性格外向，善于表达，有亲和力；工作认真、细心、主动；声音甜美，普通话标准；熟练操作各类办公软件， 打字速度快。</p>
							<p>3、有酒店预订、机票预订或旅游行业从业经验者优先考虑</p>
						
						</li>
						<li class="about-item">
							<h1>售后文员</h1>
							<p>2人/经验不限/全职</p>
							
							<p class="bn-mg-top">工作职责：</p>
							<p>1、对预订部订单问题及时跟进、反馈。</p>
							<p>2、耐心解决客户问题、对一些客户投诉，及时处理，维护公司良好形象。</p>
							<p>3、为客户提供高水准的售后服务,并以良好的心态及时解决客户提出的问题和要求,提供售后服务并能独立解决一般投诉问题；</p>
							
							<p class="bn-mg-top">任职条件：</p>
							<p>1、有酒店、旅行社工作经验优先考虑；</p>
							<p>2、反应灵敏、善于思考，具有较强的语言表达能力和沟通能力，学习能力强；</p>
							<p>3、热爱售后工作，具备一定的服务意识；</p>
							<p>4、自控力强，遇事不急燥，性格开朗，脾气好，沟通主动，有上进心，能承受一定的工作压力。</p>
							<p>5、做过旅游客服经历更佳</p>
						
						</li>
						<li class="about-item">
							<h1>运营专员</h1>
							<p>1人/经验1年以上/全职</p>
							
							<p class="bn-mg-top">职位描述：</p>
							<p>1.主要负责公司渠道客户的运营，包括发展规划，活动策划，广告投放，数据分析；能制定相关计划，统筹安排，做好执行。</p>
							<p>2.熟悉旅游行业，及各种营销工具，为销售业绩提供方案和做决策。</p>
							<p>3.具有较强数据分析能力，找出客户运营中存在问题，并提出解决方案，提升销售额，协调各部门资源以完成销售目标。</p>
							<p>4.负责产品分销体系的建立与发展，提升产品市场份额。</p>
							
							<p class="bn-mg-top">任职要求：</p>
							<p>1.有学过电商专业的优先考虑，熟悉在线旅游行业的平台。</p>
							<p>2.一年以上的网店工作经验，有旅游香港澳门酒店、阿里旅行运营经验或者淘宝店长工作经验者优先考虑。</p>
							<p>3.熟悉电子平台特别是去哪儿、携程、艺龙、淘宝旅游网。</p>
							<p>4.有良好的执行力、学习能力、沟通能力和领导能力。</p>
				
						</li>
	


					</ul>

				</div>

			</div>
		</div>

		<div class="home-footer">
			<div class="home-box home-footer-t">
				<div class="top">
					<div class="left home-contact">
						<h3>了解我们</h3>
						<router-link to="about">关于我们</router-link>
						<router-link to="contact">联系我们</router-link>
						<router-link to="contact">投诉建议</router-link>
						<router-link to="join">诚聘英才</router-link>
						
					</div>
					<div class="middle home-contact">
						<h3>客户须知</h3>
						<router-link to="introduction">预订须知</router-link>
						<router-link to="introduction">协议下载</router-link>
						<router-link to="introduction">教程下载</router-link>
					</div>
					<div class="right home-contact">
						<h3>邮箱地址</h3>
						<a href="#">国内酒店合作 chinahotel-1@cnbooking.net</a>
						<a href="#">国际酒店合作 globalhotel-33@cnbooking.net</a>
						<a href="#">OTA合作 channel-3@cnbooking.net</a>
						<a href="#">旅行社合作 chinahotel-3@cnbooking.net</a>
					</div>
					<div class="right-side home-contact">
						<h3>微信二维码</h3>
						<img src="./../../assets/img/ewm.png" alt="" />
					</div>
					<div class="clear"></div>
				</div>
				<div class="bottom">
					<img src="./../../assets/img/home-footer-logo.png" alt="" />
					<div>
						<h4>Copyright©2013-2017,dingfangyi.com.All rights reserved.</h4>
						<h4>
							<a href="#" style="text-decoration: none; color: #999;">粤ICP备17131089号</a>
							<a target="_blank" href="#" style="text-decoration: none; color: #999; float: right;">
								<img src="./../../assets/img/ga.png" />
								    粤公网安备 44030302000423号
							</a>
						</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
	import FooterS from '../Footer-s.vue'
	import loginHeader from '../loginHeader.vue'
    export default {
        components: { FooterS ,loginHeader},
        data(){
            return{
                isFixed:false,
                titleItemActive:0,
            }
        },
        mounted(){
            window.addEventListener('scroll', this.handleScroll,false)
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll,false)
        },
        methods:{
            handleScroll(){
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                this.isFixed = scrollTop>=330?true:false;
                if(!(document.querySelectorAll('.about-item')[1].offsetTop)){
                    return
                }
                var list=document.querySelectorAll('.about-item');
                if(list[1].offsetTop+300>scrollTop){
                    this.titleItemActive=0;
                }else if(list[2].offsetTop+300>scrollTop){
                    this.titleItemActive=1;
                }else if(list[3].offsetTop+300>scrollTop){
                    this.titleItemActive=2;
                }else if(list[4].offsetTop+300>scrollTop){
                    this.titleItemActive=3;
                }else if(list[5].offsetTop+300>scrollTop){
                    this.titleItemActive=4;
                }else if(list[6].offsetTop+300>scrollTop){
                    this.titleItemActive=5;
                }else{
                    this.titleItemActive=6;
                }
            },
            scrollTo(ind){
                var list=document.querySelectorAll('.about-item');
                var top=list[ind].offsetTop+310;
                this.titleItemActive=ind;
                document.body.scrollTop = document.documentElement.scrollTop = top;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/info/join.vue